@if (content) {
  <div class="main__content">
    <h1 data-cy="contactUsHeader" class="c11n-text-2xl-headline" id="decisionHeader"
    [innerHTML]="content.contactusHeading"></h1>
    <p data-cy="contactUsDesc" class="c11n-text-md" [innerHTML]="content.contactusDesc"></p>
  </div>
}
